export default __webpack_public_path__ + "img/icon.asset.70b8947d.png";